import React from "react";
import CustomModal from "../modal/CustomModal";
import { DocumentPreviewProps } from "./types/types";
import SignatureTimeline from "../timeline/TimeLine";
import DocumentContainer from "./components/DocumentContainer";
import DocumentContent from "./components/DocumentContent";
import ModalContent from "./components/ModalContent";
import DocumentViewer from "./components/DocumentViewer";

const DocumentPreview: React.FC<DocumentPreviewProps> = React.memo(
  ({
    url,
    open,
    onClose,
    signatures = [],
    customHeader,
    title = "Visualizar Documento",
    customFooter,
    timelineTitle = "Histórico de Assinaturas",
  }) => {
    const [numPages, setNumPages] = React.useState<number | null>(null);
    const hasSignatures = signatures.length > 0;

    const handleLoadSuccess = React.useCallback(({ numPages }: { numPages: number }) => {
      setNumPages(numPages);
    }, []);

    const renderSignatureTimeline = () => (
      <SignatureTimeline
        title={timelineTitle}
        items={signatures.map((signature) => ({
          id: signature.id,
          nome: signature.nome,
          email: signature.email,
          observacoes: signature.observacoes,
          data: signature.data,
          status:
            signature.status === "RECUSADO"
              ? "error"
              : signature.status === "PENDENTE" ||
                  signature.status === "CANCELADO" ||
                  signature.status === "EXPIRADO"
                ? "pending"
                : "success",
        }))}
      />
    );

    const footerDefault = <div></div>;

    return (
      <CustomModal
        showModal={open}
        onCloseModal={onClose}
        size="xl"
        tipoModal="MODAL_CENTRAL"
        scrollable={false}
        customHeader={customHeader}
        titulo={title}
        customFooter={customFooter || footerDefault}
      >
        <ModalContent>
          <DocumentContainer hasSignatures={hasSignatures}>
            <DocumentContent hasSignatures={hasSignatures}>
              <DocumentViewer url={url} numPages={numPages} onDocumentLoadSuccess={handleLoadSuccess} />
            </DocumentContent>
            {hasSignatures && renderSignatureTimeline()}
          </DocumentContainer>
        </ModalContent>
      </CustomModal>
    );
  }
);

export default DocumentPreview;
